import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import classes from './GlobalHorizontalMenu.module.css';

const GlobalHorizontalMenu = ({
  menuArr,
  onClick,
  highlightedOpt = 0,
  setHighlightedOpt,
}) => {
  const [activeDiv, setActiveDiv] = useState(highlightedOpt);
  useEffect(() => {
    setActiveDiv(highlightedOpt);
  }, [highlightedOpt]);

  const menuClickHandler = (i) => {
    setHighlightedOpt(i);
    setActiveDiv(i);
    onClick(i);
  };
  return (
    <Fragment>
      <div
        className={`${classes.timeLineParent} md:h-10 flex flex-row  bg-white cursor-pointer   `}
      >
        {menuArr.map((el, i) => (
          <Fragment key={i}>
            <div
              className={
                (activeDiv === i
                  ? `${classes.btnActive} text-tealCol-100 md:text-white border-b-4 md:border-b-0 border-tealCol-100 font-semibold `
                  : ' text-black-1000 md:text-orange-1100 font-normal  ') +
                (activeDiv === i - 1 &&
                  i !== menuArr.length - 1 &&
                  ` border-none md:border-l-0 md:border-r  `) +
                (activeDiv === i + 1 && ` border-none  md:border-r-0  `) +
                (activeDiv !== i + 1 &&
                  activeDiv !== i - 1 &&
                  i !== menuArr.length - 1 &&
                  `  md:border-r md:border-grey-990 `) +
                ' rounded-none md:rounded flex-shrink-0 text-center md:text-left flex-1 md:flex-none px-9 py-2.5 md:py-0 items-center font-roboto text-base md:text-sm  md:font-light inline-grid '
              }
              onClick={() => menuClickHandler(i)}
            >
              <p className='text-base font-normal capitalize'>{el}</p>
            </div>
          </Fragment>
        ))}
      </div>
    </Fragment>
  );
};

export default GlobalHorizontalMenu;

GlobalHorizontalMenu.propTypes = {
  // An array of a string type
  menuArr: PropTypes.arrayOf(PropTypes.string).isRequired,
};
